import { render, staticRenderFns } from "./ShareComponent.vue?vue&type=template&id=376e1bc4&scoped=true"
import script from "./ShareComponent.vue?vue&type=script&lang=ts"
export * from "./ShareComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376e1bc4",
  null
  
)

export default component.exports